import { all } from 'redux-saga/effects';
import loginSaga from './shared/loginUserSagas'
import legalsSagas from './shared/legalsSagas';
import themeSagas from './shared/themeSagas'
import featureSagas from './shared/featureSagas';
import appStatesSagas from './shared/appStatesSagas';
import CognitoLoginSagas from './shared/cognitoLoginSagas';
import topicSagas from './customerVault/topicSagas';
import topicFilesSaga from './customerVault/topicFilesSaga';
import userDetailsSagas from './shared/userDetailsSagas';
import userSagas from './customerVault/userSagas';
import filePreviewSagas from './shared/filePreviewSagas';
import topicFollowSagas from './customerVault/topicFollowSaga';
import instUserSagas from './customerVault/instUserSagas';

// Retiring
import homeSaga from '../../retired/home/homeSagas';

export default function* IndexSaga() {
	yield all([ 
		themeSagas(), 
		loginSaga(), 
		legalsSagas(), 
		homeSaga(), 
		featureSagas(),
		appStatesSagas(),
		CognitoLoginSagas(),
		topicSagas(),
		userSagas(),
		topicFilesSaga(),
		userDetailsSagas(),
		filePreviewSagas(),
		topicFollowSagas(),
		instUserSagas()
	]);
}
